import { AsyncTaskType } from '../AsyncTaskType';

export const getAsyncTaskType = (selectedWorkPlan) => {
    if (selectedWorkPlan.isRollingOut) {
        return AsyncTaskType.RolloutTask;
    }
    else if (selectedWorkPlan.isPausing) {
        return AsyncTaskType.PauseWorkplanTask;
    }
    else if (selectedWorkPlan.isStopping) {
        return AsyncTaskType.StopWorkplanTask;
    }
    else if (selectedWorkPlan.isImportingExcel) {
        return AsyncTaskType.ImportWorkplanShiftLineExcel;
    } 
    else if (selectedWorkPlan.isReloadingCoverage) {
        return AsyncTaskType.ReloadCoverage;
    }
}
